export const SUPPORTED_LANGUAGES = [
  'en',
  'es',
  'tr',
  'zh',
  'hi',
  'pt',
  'fr',
  'it',
  'ar',
];

export const LANGUAGE_SHORT_LABELS = {
  en: 'EN',
  es: 'ES',
  tr: 'TR',
  zh: 'ZH',
  hi: 'HI',
  pt: 'PT',
  fr: 'FR',
  it: 'IT',
  ar: 'AR',
};

